import { environment } from '$environments/environment'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class SystemService {

  constructor(
    private readonly http: HttpClient) { }

  pingIfBackendIsAlive(): Observable<void | null> {
    return this.http.get<void>(`${environment.apiUrl}/rest/system/alive`)
  }
}
